import React, { Component } from 'react';
import { withOktaAuth } from '@okta/okta-react';
import { Button, Header, Icon, Modal  } from 'semantic-ui-react';
import UserContext from '../contexts/UserContext';

//Basic component with logout button
// uses okta to logout
//after 15 minutes on idle a modal will pop out to ask the user if they want to stay active or logout

class Logout extends Component {

    static contextType = UserContext

  constructor(props) {
    super(props);
    this.state = { open:false};
    this.logout = this.logout.bind(this);
    this.onIdle= this._onIdle.bind(this);
    this.stayActive=this._stayActive.bind(this);
    this.sessionTimeoutRef=React.createRef();
  }

  async logout() {
    this.props.oktaAuth.signOut('/');
  }
  _onIdle(e){
    this.setState({open:true});
    this.sessionTimeoutRef.current=setTimeout(this.logout,600000);
}
_stayActive(e){
    this.setState({open:false});
    clearTimeout(this.sessionTimeoutRef.current);
}
  render() {
    return (<div>
      <Button onClick={this.logout} animated>
        <Button.Content visible>Logout</Button.Content>
        <Button.Content hidden><Icon name='log out'/></Button.Content>
      </Button>
        <Modal open={this.state.open}>
            <Header icon='exclamation circle' content='Are you still there?' />
                <Modal.Content>
                    <p>You have been idle from your computer for 15 minutes, you will be logged out soon</p>
                </Modal.Content>
            <Modal.Actions>
                <Button color='red' onClick={this.logout}>
                    <Icon name='remove' /> Logout
                </Button>
                <Button color='green' onClick={this.stayActive}>
                    <Icon name='checkmark' /> Stay signed in
                </Button>
            </Modal.Actions>
        </Modal>
        </div>
    );
  }
};


Logout = withOktaAuth(Logout);
export default Logout;